import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IInsurance {
  id: string | number;
  name: string;
  vkn: string;
  vd: string;
  point_id: string | null | number;
  is_active: boolean | number;
}

export class IInsuranceResponse {
  @Type(() => IInsurance)
  result: IInsurance;
}

export class IInsuranceslListResponse extends IPagination {
  @Type(() => IInsurance)
  results: IInsurance[];
}

export class IInsurancesQueryDto extends IQueryPaginationDto {
  name?: string;
}
